import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useGetAllVideoLinks = (houseType, houseId) =>
  useQuery(
    ['retrieveAllVideoLinks', houseType, houseId],
    async () => {
      const url =
        `/kodak-api/api/v1/media/videos/HOUSE/${houseId}`;
      const res = await axios.get(url);
      return res.data.items;
    },
    {
      enabled: Boolean(houseType) && Boolean(houseId),
      refetchOnWindowFocus: false,
    },
  );
